import { useState } from "react";
import { BarChart3, Table2 } from "lucide-react";

interface ChartTableToggleProps {
  chart: React.ReactNode;
  table: React.ReactNode;
  defaultView?: "chart" | "table";
}

export function ChartTableToggle({ chart, table, defaultView = "chart" }: ChartTableToggleProps) {
  const [view, setView] = useState<"chart" | "table">(defaultView);

  return (
    <div>
      <div className="flex justify-end mb-2">
        <div className="inline-flex rounded-md border border-admin-card-border bg-admin-card">
          <button
            type="button"
            className={`p-1.5 rounded-l-md transition-colors ${view === "chart" ? "bg-admin-primary/15 text-admin-primary" : "text-admin-text-subtle hover:text-admin-text-primary"}`}
            onClick={() => setView("chart")}
            title="Graf"
            aria-pressed={view === "chart"}
          >
            <BarChart3 className="h-4 w-4" />
          </button>
          <button
            type="button"
            className={`p-1.5 rounded-r-md transition-colors ${view === "table" ? "bg-admin-primary/15 text-admin-primary" : "text-admin-text-subtle hover:text-admin-text-primary"}`}
            onClick={() => setView("table")}
            title="Tabell"
            aria-pressed={view === "table"}
          >
            <Table2 className="h-4 w-4" />
          </button>
        </div>
      </div>
      {view === "chart" ? chart : table}
    </div>
  );
}
